import Waves from 'node-waves';
import enterView from 'enter-view';

function buttonWaves() {
  Waves.init();
  Waves.attach('.ripple-light', ['waves-light']);
  Waves.attach('.ripple-dark', ['waves-dark']);
  Waves.attach('.ripple-orange', ['waves-orange']);
}

function enterViewAnimations(sourceElement = document) {
  const animationElements = Array.from(
    sourceElement.querySelectorAll(
      '.fadeIn, .fadeInUpSmall, .fadeInLeftSmall, .fadeInRightSmall, .slideInFromTopAndShimmyUp, .shimmyDownAndUp, .rotateSideToSide',
    ),
  );

  const animationElementsLateSlide = Array.from(
    document.querySelectorAll(
      '.slideOutRightLarge, .slideOutRightLargeAndReturnReversed',
    ),
  );

  animationElements.length &&
    enterView({
      selector: animationElements,
      offset: 0.25,
      enter(el) {
        el.classList.add('entered');
      },
    });
  animationElementsLateSlide.length &&
    enterView({
      selector: animationElementsLateSlide,
      offset: 0.75,
      enter(el) {
        el.classList.add('entered');
      },
    });
}

function moreThanDogsEnterViewAnimations() {
  const enterViewElements = Array.from(
    document.querySelectorAll('[data-mtd-enter-view]'),
  );

  enterViewElements.length &&
    enterView({
      selector: enterViewElements,
      offset: 0.25,
      enter: (el) => el.classList.add('in'),
      exit: (el) => el.classList.remove('in'),
    });
}

export function init() {
  buttonWaves();
  enterViewAnimations(document);
  moreThanDogsEnterViewAnimations();

  jQuery(window).on('module.reinit', (e, modalContentElement) => {
    enterViewAnimations(modalContentElement);
  });
}
